
import { getCompanySet, modifyCompanySet } from '@/api/system';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'AutoAssign',
  components: {
  }
})
export default class extends Vue {
    // private activeName = 'first'
    private formAutoAssign:any={
      auto_assign_order_type: [],
      auto_assign_month: 0
    }
    created() {
      this.getCompanySet();
    }
    private getCompanySet() {
      let params:any = {};
      params.user_id = UserModule.getUserId;
      params.company_id = UserModule.getCompanyId;
      params.vip_level = (UserModule.company as any).vip_level;
      getCompanySet(params).then(res => {
        if (res.data && res.data.companySet) {
          this.formAutoAssign.auto_assign_order_type.push(parseInt(res.data.companySet.auto_assign_order_type));
        }
      }).catch(err => {
        let msg = err.msg;
      });
    }
    private autoAssignChage(val:any) {
      if (val.length === 2) {
        this.formAutoAssign.auto_assign_order_type.splice(0, 1);
      }
      this.saveAutoAssign();
    }
    private autoAssignDayChage(val:any) {

    }
    // 保存设置
    private saveAutoAssign() {
      let params:any = {};
      params.user_id = UserModule.getUserId;
      params.company_id = UserModule.getCompanyId;
      if (!this.formAutoAssign.auto_assign_order_type || this.formAutoAssign.auto_assign_order_type.length < 1) {
        params.auto_assign_order_type = 0;
      } else {
        params.auto_assign_order_type = this.formAutoAssign.auto_assign_order_type[0];
      }

      this.saveCopanySet(params);
    }
    private saveCopanySet(params:any) {
      modifyCompanySet(params).then(res => {
        this.showSuccessMsg((res as any).msg);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
    private showErrorMsg(msg: string) {
      this.$notify({
        title: '提示',
        message: msg,
        offset: 100,
        type: 'error'
      });
    }
    private showSuccessMsg(msg: string) {
      this.$notify({
        title: '提示',
        message: msg,
        offset: 100,
        type: 'success'
      });
    }
}
